module.exports = __webpack_public_path__ + "static/img/iphoneX-bg.9fccc862.jpg";